import { CompanyDto } from './company-dto.model';


export class BranchDto implements IBranchDto {
    id!: number;
    company!: CompanyDto;
    branchName!: string | undefined;
    contactNo!: string | undefined;
    isActive!: boolean;

    constructor(data?: IBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.branchName = _data["branchName"];
            this.contactNo = _data["contactNo"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["contactNo"] = this.contactNo;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IBranchDto {
    id: number;
    company: CompanyDto;
    branchName: string | undefined;
    contactNo: string | undefined;
    isActive: boolean;
}

